<div class="stock-hold-timeout-dialog p-4" data-testid="stock-hold-timeout-dialog">
  <form [formGroup]="configForm" class="space-y-4">
    <div class="w-full">
      <label for="hold-category" class="block text-sm font-medium text-gray-700 mb-2">
        {{ 'stock_hold_timeout.form.hold_category' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-select
        formControlName="holdCategory"
        inputId="hold-category"
        [options]="categoryOptions"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'stock_hold_timeout.form.select_category' | translate"
        class="w-full"
        [class.p-invalid]="showErrors() && configForm.get('holdCategory')?.invalid"
      />
      @if (showErrors() && configForm.get('holdCategory')?.invalid) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'stock_hold_timeout.form.errors.category_required' | translate }}
        </p>
      }
    </div>

    <div class="w-full">
      <label for="timeout-minutes" class="block text-sm font-medium text-gray-700 mb-2">
        {{ 'stock_hold_timeout.form.timeout_minutes' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-inputNumber
        formControlName="timeoutMinutes"
        inputId="timeout-minutes"
        [min]="1"
        [useGrouping]="false"
        [showButtons]="false"
        class="w-full"
        [class.p-invalid]="showErrors() && configForm.get('timeoutMinutes')?.invalid"
      />
      @if (showErrors() && configForm.get('timeoutMinutes')?.invalid) {
        <p class="text-red-500 text-xs mt-1">
          {{ 'stock_hold_timeout.form.errors.timeout_required' | translate }}
        </p>
      }
    </div>

    <div class="flex items-center">
      <span class="mr-3 text-sm font-medium text-gray-700">
        {{ 'stock_hold_timeout.form.enabled' | translate }}
      </span>
      <p-checkbox
        formControlName="enabled"
        inputId="enabled"
        [binary]="true"
      />
    </div>
  </form>

  <div class="dialog-footer mt-6">
    <div class="error-message-container mb-3">
      @if (errorMessage()) {
        <p-message severity="error" variant="simple" size="small" [text]="errorMessage() || undefined" />
      }
    </div>
    <div class="flex justify-end gap-3">
      <app-button
        [label]="'common.actions.cancel' | translate"
        type="secondary"
        [outlined]="true"
        (emitOnClick)="onCancel()"
      />
      <app-button
        [label]="'common.actions.save' | translate"
        type="info"
        [disabled]="saving()"
        (emitOnClick)="onSave()"
      />
    </div>
  </div>
</div>
